import { Grid, GridProps } from '@chakra-ui/react';

export function FormSectionGrid(props: GridProps): JSX.Element {
  return (
    <Grid
      w="100%"
      gap="space_unit.x2"
      templateColumns="repeat(1,350px)"
      {...props}
    />
  );
}
